import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import classnames from 'classnames';
import useLoyaltyProgram from '../../hooks/loyalty/useLoyaltyProgram';
import useAppMethods from '../../hooks/utility/useAppMethods';

interface Props {
  price: number;
  quantity: number;
  className?: string;
}

export default function EarnPointsTag(props: Props) {
  const { price, quantity, className } = props;
  const { t } = useTranslation(null, { keyPrefix: 'Components:LoyaltyProgram:EarnPointsTag' });
  const { toggleFreeProductsModal } = useAppMethods();
  const { hasLoyaltyPromotion, loyalty, isPerEligibleItem } = useLoyaltyProgram();

  const value = useMemo(
    () => (price / quantity > loyalty?.reward_threshold ? loyalty?.reward * quantity : 0),
    [price, quantity, loyalty],
  );

  return (
    hasLoyaltyPromotion &&
    isPerEligibleItem &&
    value > 0 && (
      <button
        className={classnames('h-7 bg-brand-primary px-md rounded-md text-white', className)}
        onClick={() => toggleFreeProductsModal({ openModal: true })}
      >
        <p className="text-sm font-medium">{t('text', { count: value })}</p>
      </button>
    )
  );
}
